@switch (simple) {
  @case (true) {
    <i
      (click)="toggle(!checked)"
      [ngClass]="{
        'mutual-opacity theme-simple-icon onact96-not': true,
        'fi-sun': !checked && simpleStyle === 'line',
        'fi-sun-filled': !checked && simpleStyle === 'fill',
        'fi-moon': checked && simpleStyle === 'line',
        'fi-moon-filled': checked && simpleStyle === 'fill',
      }"
    ></i>
  }

  @default {
    <div class="theme-slide" [class.checked]="checked">
      <mat-slide-toggle
        #toggler
        [checked]="checked"
        [disabled]="disabled"
        [disableRipple]="true"
        (change)="toggle($event.checked)"
      ></mat-slide-toggle>
      <!-- <i
        [ngClass]="{
          'theme-icon': true,
          'theme-light': !checked,
          'fi-sun': !checked && simpleStyle === 'line',
          'fi-sun-filled': !checked && simpleStyle === 'fill',
          'theme-dark': checked,
          'fi-moon': checked && simpleStyle === 'line',
          'fi-moon-filled': checked && simpleStyle === 'fill',
        }"
      ></i> -->
    </div>
  }
}
